"use client";

// CTA for use-case pages: the shared Vercel-style agent CTA.

import { AgentCta } from "@/components/homepage/agent-cta";

export function UseCaseCta() {
  return <AgentCta />;
}
